import React from 'react';
import {withRouter} from 'react-router-dom';

//Context
import {AppContext} from '../../AppModule/Context';
import {withExpertHomeContext} from '../../screens/ExpertHome/ExpertHomeContextProvider';
import {withWidgetContext} from '../widgetComponent/widgetContextProvider';

//Constants
import VIDABOO_CONSTANTS from '../../config/consts';

//Services
import {PrivateRoomService} from '../../services/websocketService';
// import UtilsService from '../../services/utilsService';
import chatService from '../../services/chatService';
import expertHomeService from '../../services/expertHomeService';
import NotifyCustomerService from '../../services/restServices/notifyCustomerService';
import ChatContainerRender from './chatContainerRender';
import utilsService from '../../services/utilsService';
import NotificationComponent from '../common/genericComponents/notificationComponent';
import SendMailComponent from './sendMailComponent';
import ShimmerWithEmptyImageComponent from '../common/genericComponents/redesign/shimmerWithEmptyImageComponent/shimmerWithEmptyImageComponent';

class ChatContainer extends React.Component {
  constructor() {
    super();
    // this.fncObj = props.fncObj;
    this.prevPeersStatus = {};
    this.state = {
      chatBoxes: {},
      shouldCollectUserInfo: false,
      showChatContainer: false,
      showEmailSpinner: false,
      isEmailBtnFlow: false,
      sendEmailToOfflineClient: false,
      offlineClientRoomDto: null,
      offlineClientEmails: null,
      offlineClientEmailSubject: 'You asked a question. Response here',
      offlineClientEmailContent: null,
      offlineClientRoomDtoMentorId: null,
      areAllClientEmailsValid: true,
      emailReceivedRooms: [], // saving list of users we've previously sent an email to.
      notificationPopupRecievedRooms: [], //saving list of users whose email id is not available and previously notification popup have been shown
      showNotificationPopup: false,
      notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.LIGHT,
      notificationText: '',
    };
    this.chatContainerTimeout = null;
  }
  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
    if (this.props.isDemo) this.initDemoChatContainer();
    else this.initChatContainer();
    this.collectUserInfo();
  }

  collectUserInfo = () => {
    if (this.props.isMentor) {
      this.setState({shouldCollectUserInfo: false});
      return;
    }
    if (
      this.props.mentor?.mentorDto.appControlDto.requireContactDetailsForChat &&
      !this.props.isDemo
    ) {
      const shouldCollectUserInfo = utilsService.shouldCollectPeerInfo(
        this.props.mentor?.mentorDto?.mentorOwnerId,
        this.props.widgetDto,
      );
      this.setState({shouldCollectUserInfo});
    } else {
      this.setState({shouldCollectUserInfo: false});
    }
  };

  componentWillUnmount = () => {
    if (this.chatContainerTimeout) clearTimeout(this.chatContainerTimeout);
    if (this.callSendFuncTimeoutId) {
      clearTimeout(this.callSendFuncTimeoutId);
    }
    this.deleteDoWhenMessageReceivedFromPrivateRoom &&
      this.deleteDoWhenMessageReceivedFromPrivateRoom();
    this.deleteConnectToPrivateChatRoom && // for group chat room (meeting room) on customer side
      this.deleteConnectToPrivateChatRoom();
    this.deleteConnectToPrivateRoom && this.deleteConnectToPrivateRoom(); // for private or shared room on customer side
  };
  initDemoChatContainer = () => {
    const startChatObj = {};
    const peerUserId = this.props.currentUser.userId;
    const demoChatRoom = {roomId: peerUserId};
    const newChatBoxObj = {
      peerUserId,
      currentUser: this.props.currentUser,
      firstMessage: startChatObj.firstMessage,
      automaticMessage: startChatObj.automaticMessage,
      nonRespondantMessage: startChatObj.nonRespondantMessage,
      isMentor: this.props.isMentor,
      peerName: startChatObj.peerName,
      isVideo: false,
      isInWidget: true,
      sendAnalyticsToParent: false,
      chatMessages: [],
      readMessagesByMessageTag: [],
      roomType: VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_ON_ONE,
      chatRoomDto: demoChatRoom,
    };

    newChatBoxObj.fncObjToChatBox = {};
    let tempChatBoxes = {...this.state.chatBoxes};

    tempChatBoxes[peerUserId] = newChatBoxObj;

    this.setState({chatBoxes: tempChatBoxes, showChatContainer: true});
    this.setState({
      selectedChatRoomDto: demoChatRoom,
    });
  };
  // getPeerDetails = (message) => {
  //   var startChatObj = {};
  //   var peerUserId = message.content.senderUserId;
  //   if (this.props.isMentor === false) {
  //     // if on client side, we have only one peer and it's the mentor.
  //     if (ChatService.fncObj.peerSpecificFnc[peerUserId]) {
  //       startChatObj =
  //         ChatService.fncObj.peerSpecificFnc[peerUserId].getPeerDetails(
  //           peerUserId,
  //         );
  //     } else {
  //       console.debug('Error CH101: peerUserId does not exist');
  //       startChatObj = {
  //         peerName: message.content.senderProfileName,
  //         peerImage: '',
  //         peerUserId: peerUserId,
  //       };
  //     }
  //   } else {
  //     startChatObj = {
  //       peerName: '',
  //       peerImage: '',
  //       peerUserId: peerUserId,
  //     };
  //   }
  //   return startChatObj;
  // };
  initChatContainer() {
    if (!this.props.isMentor) {
      this.startChatCustomerSide();
    } else {
      this.setState({showChatContainer: true});
    }
    this.registerListeners = () => {
      this.deleteDoWhenMessageReceivedFromPrivateRoom =
        PrivateRoomService.doWhenMessageReceivedFromPrivateRoom(
          VIDABOO_CONSTANTS.WEBSOCKET_PRIVATE_ROOM_ALL,
          this.doWhenMessageReceivedFromPrivateRoom,
        );
    };

    this.registerListeners();

    //todo : Ilan -> need to review
    //Earlier this.props.selectedRoomDto was initially null and was set in chatCenter after the chat roooms response but now selectedRoomDto is set after isChatRoomsDataFetched is set to true. Hence selectedRoomDto is will not be null initially here and createNewChatBoxIfRequired will not be called inside componentDidUpdate
    if (this.props.selectedRoomDto) {
      this.createNewChatBoxIfRequired(this.props.selectedRoomDto, null, true);
    }

    // ChatService.addFnc(this.fncObj);
  }
  createChatBox = (currentUser, startChatObj, peerUserId, chatRoomDto) => {
    if (!this.state.chatBoxes[chatRoomDto.roomId]) {
      const sendAnalyticsToParent =
        this.props.isInWidget === true &&
        startChatObj.sendAnalyticsToParent === true;
      const newChatBoxObj = {
        peerUserId: peerUserId,
        currentUser: currentUser,
        isMentor: this.props.isMentor,
        peerName: startChatObj.peerName,
        isVideo: this.props.isVideo,
        isInWidget: this.props.isInWidget,
        chatMessages: [],
        readMessagesByMessageTag: [],
        chatRoomDto,
        // Customer side only:
        sendAnalyticsToParent: sendAnalyticsToParent,
        firstMessage: startChatObj.firstMessage,
        automaticMessage: startChatObj.automaticMessage,
        nonRespondantMessage: startChatObj.nonRespondantMessage,
        nonRespondantMessageTime: startChatObj.nonRespondantMessageTime,
      };

      newChatBoxObj.fncObjToChatBox = {};

      // let tempChatBoxes = {...this.state.chatBoxes};

      // // console.debug("chatBoxes value is", this.state.chatBoxes);

      // tempChatBoxes[peerUserId] = newChatBoxObj;
      // this.setState({chatBoxes: tempChatBoxes});

      return newChatBoxObj;
      // console.debug("tempChatBoxes", tempChatBoxes);
    } else {
      console.debug('tried to create a chatbox which already exists');
    }
  };
  componentDidUpdate = (prevProps) => {
    // if (
    //   this.props.isMentor &&
    //   this.props.startChatWithPeer &&
    //   this.props.startChatWithPeer !== this.startChatWithPeerPrev
    // ) {
    //   this.startChatWithPeerPrev = this.props.startChatWithPeer;
    //   if (!this.props.isDemo) this.startChatWithPeer(this.props.startChatObj);
    // } else if (
    //   !this.props.isMentor &&
    //   this.state.startChatWithPeer &&
    //   this.state.startChatWithPeer !== this.startChatWithPeerPrev
    // ) {
    //   this.startChatWithPeerPrev = this.state.startChatWithPeer;
    //Update startChatObj object when peer status is changed
    // if (
    //   this.prevPeerStatus &&
    //   this.prevPeerStatus[this.props.mentor.mentorDto.mentorOwnerId] !==
    //     this.context.peersStatus[this.props.mentor.mentorDto.mentorOwnerId]
    // ) {
    //   let startChatObj = {...this.state.startChatObj};
    //   const automaticMessage = this.props.mentor.mentorDto.appControlDto
    //     .automaticChatMessage;
    //   if (
    //     this.context.peersStatus[this.props.mentor.mentorDto.mentorOwnerId] ===
    //     VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE
    //   ) {
    //     if (automaticMessage !== '') {
    //       startChatObj.automaticMessage = automaticMessage;
    //     }
    //   } else {
    //     const automaticMessageWhenOffline = this.props.mentor.mentorDto
    //       .appControlDto.automaticChatMessageWhenOffline;
    //     if (automaticMessageWhenOffline !== '') {
    //       startChatObj.automaticMessage = automaticMessageWhenOffline;
    //     } else startChatObj.automaticMessage = automaticMessage;
    //   }
    //   this.setState({startChatObj});
    //   debugger;
    //   this.prevPeerStatus[
    //     this.props.mentor.mentorDto.mentorOwnerId
    //   ] = this.context.peersStatus[this.props.mentor.mentorDto.mentorOwnerId];
    // }
    // if (!this.props.isDemo) this.startChatWithPeer(this.state.startChatObj);
    // }
    if (
      prevProps.refreshShouldCollectUserInfo !==
        this.props.refreshShouldCollectUserInfo &&
      this.props.refreshShouldCollectUserInfo
    ) {
      this.collectUserInfo();
    }
    if (
      this.props.widgetContext?.privateChatRoomDto?.privateChatRoomId &&
      prevProps.widgetContext.privateChatRoomDto?.privateChatRoomId !==
        this.props.widgetContext?.privateChatRoomDto?.privateChatRoomId
    ) {
      this.handlePrivateChatRoomCreationCustomer();
    }
    if (
      this.props.widgetContext?.selectedChatRoomId &&
      this.props.widgetContext.selectedChatRoomId !==
        prevProps.widgetContext?.selectedChatRoomId
    ) {
      this.setPrivateChatRoomDto();
    }
    if (
      this.props.selectedRoomDto &&
      prevProps.selectedRoomDto !== this.props.selectedRoomDto
    ) {
      this.createNewChatBoxIfRequired(this.props.selectedRoomDto, null, true);
    }
    if (
      prevProps.updatedChatRoomDto?.roomId !==
        this.props.updatedChatRoomDto?.roomId &&
      this.props.updatedChatRoomDto?.roomId
    ) {
      let newChatBoxes = {...this.state.chatBoxes};
      let chatboxToBeUpdated =
        newChatBoxes[this.props.updatedChatRoomDto.roomId];
      if (this.props.updatedChatRoomDto.chatRoomPeerInfoDto) {
        chatboxToBeUpdated.chatRoomDto.chatRoomPeerInfoDto = {
          ...this.props.updatedChatRoomDto.chatRoomPeerInfoDto,
        };
      }
      if (this.props.updatedChatRoomDto.roomInfoDto) {
        chatboxToBeUpdated.chatRoomDto.roomInfoDto = {
          ...this.props.updatedChatRoomDto.roomInfoDto,
        };
      }
      this.setState({
        chatBoxes: newChatBoxes,
      });
      this.props.resetUpdatedChatRoomDto();
    }
  };

  setPrivateChatRoomDto = () => {
    //this code updated the selectedChatRoomDto in case of group chat room
    if (
      this.props.widgetContext?.privateChatRoomDto?.privateChatRoomId ===
      this.props.widgetContext.selectedChatRoomId
    ) {
      const oneOnManyRoomId =
        this.props.widgetContext?.privateChatRoomDto?.privateChatRoomId;
      if (oneOnManyRoomId) {
        this.setState({
          selectedChatRoomDto:
            this.state.chatBoxes[oneOnManyRoomId].chatRoomDto,
        });
      }
    } else {
      //there can be only 2 rooms on customer side, so if one is ONE_TO_MANY other will be ONE_ON_ONE
      const oneOnOneRoomId = Object.keys(this.state.chatBoxes).find(
        (roomId) =>
          roomId !==
          this.props.widgetContext?.privateChatRoomDto?.privateChatRoomId,
      );
      if (oneOnOneRoomId) {
        this.setState({
          selectedChatRoomDto: this.state.chatBoxes[oneOnOneRoomId].chatRoomDto,
        });
      }
    }
  };

  handlePrivateChatRoomCreationCustomer = () => {
    const startChatObj = {
      peerName: this.props.mentor.firstName + ' ' + this.props.mentor.lastName,
      peerUserId: this.props.widgetContext.privateChatRoomDto.privateChatRoomId,
      roomId: this.props.widgetContext.privateChatRoomDto.privateChatRoomId,
      roomType: VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_TO_MANY,
    };

    chatService.getChatRoomInfoByChatRoomId(
      this.props.widgetContext.privateChatRoomDto.privateChatRoomId,
      (chatRoomDto) => {
        this.createNewChatBoxIfRequired(chatRoomDto, startChatObj);
        //This is supposed to connect only incase of customer
        this.deleteConnectToPrivateChatRoom =
          PrivateRoomService.connectToPrivateRoom(
            this.props.widgetContext.privateChatRoomDto.privateChatRoomId,
            this.props.currentUser.userId,
          );
      },
    );
  };

  doWhenMessageReceivedFromPrivateRoom = (data) => {
    // let peerUserId = data.senderUserId; // will be replaced when we finalize
    // let peerUserId =
    //   wsRoomType === VIDABOO_CONSTANTS.WEBSOCKET_ROOM_TYPES.LISTENING
    //     ? data.senderUserId
    //     : data.targetRoomId;

    // until now in money transaction messages that were either INIT or REFUND we saw senderUserId was the mentorId
    // therefore they were considered from peer all the time
    // if (
    //   data.messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT &&
    //   data.content.SubType === VIDABOO_CONSTANTS.CHAT_SUBTYPES.MONEY_TRANSACTION
    // ) {
    // data = {...data, senderUserId: data.content.senderObjectId};
    // }
    const chatRoomId = data.content?.targetChatRoomId;
    if (
      data.messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT &&
      data.senderUserId !== this.props.currentUser.userId && // when we decide to listen to same mentor messages, start here
      (!this.props.restrictToPeer ||
        this.props.restrictToPeer === data.content.senderObjectId ||
        data.targetRoomId ===
          this.props.widgetContext?.privateChatRoomDto?.privateChatRoomId ||
        // todo 1720 : Ilan/Jashan : verify this condition. this code enables the handling of task owner change on the "customer" side
        (this.state.chatBoxes[chatRoomId] &&
          this.state.chatBoxes[chatRoomId].chatRoomDto.ownerObjectType ===
            VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR))
    ) {
      if (data.messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT) {
        if (
          !this.state.chatBoxes[chatRoomId] &&
          data.content.SubType !==
            VIDABOO_CONSTANTS.CHAT_SUBTYPES.TRANSITION_TO_MENTOR_CHAT_ROOM
          // reason for adding subtype condition : we were not doing anything inside the if block and when transition of that room is done, the room in chaboxes may exist so we need to perform some action for this type
        ) {
          // var startChatObj = this.getPeerDetails(data);
          // startChatObj.firstMessage = data;
          // startChatObj.roomType = VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_ON_ONE;
          // this.createChatBox(this.props.currentUser, startChatObj, peerUserId);
        } else {
          if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.CHAT_SUBTYPES.TASK_OWNER_UPDATE
          ) {
            this.doWhenTaskOwnerChanged(
              data.content.targetChatRoomId,
              data.content.newTaskOwnerMentorId,
            );
          } else if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.CHAT_SUBTYPES.TRANSITION_TO_MENTOR_CHAT_ROOM
          ) {
            const authorizedSelectedMentorIds =
              expertHomeService.getAuthorizedSelectedMentorIds(
                this.props.expertHomeContext.selectedMentorDtos,
                this.props.currentUser.userId,
              );
            // check if the mentor is selected or not
            const isMentorSelected = authorizedSelectedMentorIds.find(
              (mentorId) => mentorId === data.content.mentorId,
            );
            if (isMentorSelected) {
              const oneOnOneRoomId = data.content.targetChatRoomId;
              chatService.getChatRoomInfoByChatRoomId(
                oneOnOneRoomId,
                (extendedChatRoomDto) => {
                  this.props.openRoom(extendedChatRoomDto);
                },
              );
            }
          }
        }
      }
    } else {
      if (
        data.messageType ===
          VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT_NO_SAVE &&
        data.content.SubType ===
          VIDABOO_CONSTANTS.CHAT_NO_SAVE_SUBTYPES.DELETE_CHAT_ROOM &&
        this.props.currentUser.guest === true
      ) {
        const deletedChatRoomId = data.content.chatRoomId;
        if (this.state.chatBoxes[deletedChatRoomId]) {
          this.context.setNotificationPopUpData({
            notificationTxt: 'This conversation has been deleted',
            notificationType:
              VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
            rejectBtnTxt: 'Reload',
            rejectBtnFunc: () => {
              window.location.reload();
            },
          });
          this.context.setShowNotificationPopUp(true);
        }
      }
      // console.debug('chat-container : chat not belongs here');
    }
  };

  // startChatWithPeer = (startChatObj) => {
  //   debugger;
  // console.debug('STARTED CHAT WITH PEER');
  // this.createChatBox(
  //   this.props.currentUser,
  //   startChatObj,
  //   startChatObj.peerUserId,
  // );
  // };

  callSendMessageFunc = (msg, msgType, metaData) => {
    if (this.refToChatBox && this.refToChatBox.sendMessage) {
      this.refToChatBox.sendMessage(msg, msgType, metaData);
    } else {
      if (this.callSendFuncTimeoutId) {
        clearTimeout(this.callSendFuncTimeoutId);
      }
      this.callSendFuncTimeoutId = setTimeout(() => {
        this.callSendMessageFunc(msg, msgType, metaData);
      }, 150);
    }
  };
  getCreateChatRoomByOwnerAndGuests = (
    ownerObjectType,
    ownerObjectId,
    guestUserIds,
  ) => {
    // const roomUserIds = [this.myUserId, this.peerUserId];

    return new Promise((resolve, reject) => {
      chatService.getCreateChatRoomByOwnerAndGuests(
        ownerObjectType,
        ownerObjectId,
        guestUserIds,
        (chatRoomDto) => {
          resolve(chatRoomDto);
        },
        (error) => {
          reject(error);
        },
      );
    });
  };
  createNewChatBoxIfRequired = (
    chatRoomDto,
    chatBoxObj,
    shoudBringRoomToFocus,
  ) => {
    if (this.state.chatBoxes[chatRoomDto.roomId]) return; // already exists;

    // const peerUserId = Object.keys(chatRoomDto.users).find(
    //   (userId) => userId !== this.props.currentUser.userId,
    // );

    const peerUserId = !this.props.isMentor
      ? this.props.mentor.mentorDto.mentorOwnerId
      : chatRoomDto.participants?.find(
          (participant) =>
            participant.objectType ===
            VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.GUEST,
        ).objectId;
    const newChatBoxes = {...this.state.chatBoxes};
    chatBoxObj = chatBoxObj ?? {peerName: chatRoomDto?.peerUserName}; // TODOBR - fix this
    newChatBoxes[chatRoomDto.roomId] = this.createChatBox(
      this.props.currentUser,
      chatBoxObj,
      peerUserId,
      chatRoomDto,
    );

    if (this.props.isMentor) {
      const authorizedMentorIds =
        expertHomeService.getAuthorizedSelectedMentorIds(
          this.props.expertHomeContext.selectedMentorDtos,
        );
      newChatBoxes[chatRoomDto.roomId].chatRoomDto.participantsInfo =
        expertHomeService.getChatParticipantsInfo({
          roomDto: newChatBoxes[chatRoomDto.roomId].chatRoomDto,
          chatRooms: this.props.chatRooms,
          widgetDtos: this.props.expertHomeContext.widgetDtos,
          authorizedMentorIds,
          currentUserId: this.props.currentUser.userId,
        });
    } else {
      newChatBoxes[chatRoomDto.roomId].chatRoomDto.participantsInfo =
        expertHomeService.getChatParticipantsInfo({
          roomDto: newChatBoxes[chatRoomDto.roomId].chatRoomDto,
          chatRooms: [],
          widgetDtos: [this.props.widgetDto],
          authorizedMentorIds: [],
          currentUserId: this.props.currentUser.userId,
          cExtendedMentorDto: this.props.mentor,
        });
    }
    this.setState({chatBoxes: newChatBoxes});
    if (shoudBringRoomToFocus && !VIDABOO_CONSTANTS.NATIVE_APP) {
      this.bringRoomToFocus(chatRoomDto);
    }
  };

  handleTransitionChatRoomOwnership = (
    chatRoom,
    newTaskOwnerMentorId,
    transitionChatRoomCloneRecipe,
  ) => {
    this.props.setIsTakeOwnershipFlowRunning(true);
    chatService.transitionChatRoomOwnership(
      chatRoom.roomId,
      newTaskOwnerMentorId,
      transitionChatRoomCloneRecipe,
      (response) => {
        this.doWhenTaskOwnerChanged(
          response.chatRoomDto.roomId,
          response.chatRoomDto.taskOwnerMentorId,
        );
        const toastObj = utilsService.getToastObj({
          toastTitle: 'Chat ownership changed',
          toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS,
        });
        this.context.addToastObj(toastObj);
        this.props.setIsTakeOwnershipFlowRunning(false);
      },
      () => {
        const toastObj = utilsService.getToastObj({
          toastTitle: 'Failed to change ownership',
          toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
        });
        this.context.addToastObj(toastObj);
        this.props.setIsTakeOwnershipFlowRunning(false);
      },
    );
  };

  doWhenTaskOwnerChanged = (roomId, newTaskOwnerMentorId) => {
    let newChatBoxes = {...this.state.chatBoxes};
    let chatBoxToBeUpdated = newChatBoxes[roomId];
    if (chatBoxToBeUpdated) {
      chatBoxToBeUpdated.chatRoomDto = {
        ...chatBoxToBeUpdated.chatRoomDto,
        taskOwnerMentorId: newTaskOwnerMentorId,
      };
    }
    this.setState({chatBoxes: newChatBoxes});
  };

  handleTaskOwnerLockChange = (roomId, currentIsTaskOwnerLocked) => {
    const newIsTaskOwnerLocked = !currentIsTaskOwnerLocked;
    this.context.setShowHeaderUpdateBar(true);
    chatService.toggleTaskOwnerLock(
      {
        chatRoomId: roomId,
        isTaskOwnerLocked: newIsTaskOwnerLocked,
      },
      (response) => {
        let newChatBoxes = {...this.state.chatBoxes};
        let chatBoxToBeUpdated = newChatBoxes[roomId];
        if (chatBoxToBeUpdated) {
          chatBoxToBeUpdated.chatRoomDto = {
            ...chatBoxToBeUpdated.chatRoomDto,
            isTaskOwnerLocked: response.chatRoomDto.isTaskOwnerLocked,
          };
        }
        const toastObj = utilsService.getToastObj({
          toastTitle: `Successfully ${response.chatRoomDto.isTaskOwnerLocked ? 'locked' : 'unlocked'} task owner`,
          toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS,
        });
        this.context.addToastObj(toastObj);
        this.context.setShowHeaderUpdateBar(false);
        this.setState({chatBoxes: newChatBoxes});
      },
      () => {
        const toastObj = utilsService.getToastObj({
          toastTitle: `Failed to ${newIsTaskOwnerLocked ? 'lock' : 'unlock'} task owner`,
          toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
        });
        this.context.addToastObj(toastObj);
        this.context.setShowHeaderUpdateBar(false);
      },
    );
  };

  bringRoomToFocus = (chatRoomDto) => {
    const chatListBoxesContainer = document.getElementById(
      'et-chat-list-boxes-container-div',
    );
    if (chatListBoxesContainer) {
      const chatListRowDiv = document.getElementById(
        chatRoomDto.roomType + chatRoomDto.roomId,
      );
      if (chatListRowDiv) {
        const chatListBoxesContainerRect =
          chatListBoxesContainer.getBoundingClientRect();
        const chatListRowDivRect = chatListRowDiv.getBoundingClientRect();
        const isInView =
          chatListRowDivRect.top >= chatListBoxesContainerRect.top &&
          chatListRowDivRect.bottom <= chatListBoxesContainerRect.bottom;
        if (!isInView) {
          chatListBoxesContainer.scrollTo({
            top: chatListRowDiv.offsetTop - 50,
            behavior: 'smooth',
          });
        }
      }
    }
  };

  startChatCustomerSide = async () => {
    //wait till peerStatus is not valid
    if (this.chatContainerTimeout) clearTimeout(this.chatContainerTimeout);
    const guestUserIds = [this.props.currentUser.userId];
    const ownerObjectType = this.props.inTeamChatScenario
      ? VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR
      : VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.MENTOR;
    const ownerObjectId = this.props.mentor.mentorDto.mentorId;
    const chatRoomDto = await this.getCreateChatRoomByOwnerAndGuests(
      ownerObjectType,
      ownerObjectId,
      guestUserIds,
    );
    this.deleteConnectToPrivateRoom = PrivateRoomService.connectToPrivateRoom(
      chatRoomDto.roomId,
      this.props.currentUser.userId,
    );
    this.props.widgetContext.hideChatTransitionAnim();
    if (this.props.inTeamChatScenario) {
      const startChatObj = {
        peerName: VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI,
        automaticMessage:
          this.props.mentor.mentorDto.appControlDto.automaticChatMessage ??
          VIDABOO_CONSTANTS.CHAT_AUTOMATIC_MSG,
        sendAnalyticsToParent: false,
        roomType: VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_ON_ONE,
      };
      this.createNewChatBoxIfRequired(chatRoomDto, startChatObj);
      this.setState({
        showChatContainer: true,
        selectedChatRoomDto: chatRoomDto,
      });
    } else {
      if (
        !this.context.peersStatus.hasOwnProperty(
          this.props.mentor.mentorDto.mentorOwnerId,
        )
      ) {
        this.chatContainerTimeout = setTimeout(() => {
          this.startChatCustomerSide();
        }, 500);
        return;
      }
      this.setState({showChatContainer: true});
      const peerFirstLastName =
        this.props.mentor.firstName + ' ' + this.props.mentor.lastName;
      let nonRespondantMessage, nonRespondantMessageTime;
      if (this.props.mentor.mentorDto.appControlDto) {
        nonRespondantMessage =
          this.props.mentor.mentorDto.appControlDto
            .automaticNonRespondingMessage;
        nonRespondantMessageTime =
          this.props.mentor.mentorDto.appControlDto
            .automaticNonRespondingMessageTime * 1000;
      }
      if (!nonRespondantMessage)
        nonRespondantMessage =
          VIDABOO_CONSTANTS.CHAT_AUTO_RESPONDER
            .DEFAULT_MENTOR_NOT_RESPONDED_MESSAGE;

      if (!nonRespondantMessageTime)
        nonRespondantMessageTime =
          VIDABOO_CONSTANTS.CHAT_AUTO_RESPONDER
            .DEFAULT_TIME_TILL_NON_RESPONSE_MESSAGE;
      const startChatObj = {
        peerName: peerFirstLastName,
        peerUserId: this.props.mentor.mentorDto.mentorOwnerId,
        nonRespondantMessage,
        nonRespondantMessageTime,
        sendAnalyticsToParent: this.props.enableWidgetAnalyticsForward,
        roomType: VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_ON_ONE,
      };
      const automaticMessage =
        this.props.mentor.mentorDto.appControlDto.automaticChatMessage ??
        VIDABOO_CONSTANTS.CHAT_AUTOMATIC_MSG;
      if (
        this.context.peersStatus[this.props.mentor.mentorDto.mentorOwnerId] ===
          VIDABOO_CONSTANTS.AVAILABILITY_STATES.AVAILABLE ||
        this.context.peersStatus[this.props.mentor.mentorDto.mentorOwnerId] ===
          VIDABOO_CONSTANTS.AVAILABILITY_STATES.BUSY
      ) {
        if (automaticMessage !== '') {
          startChatObj.automaticMessage = automaticMessage;
        }
      } else {
        const automaticMessageWhenOffline =
          this.props.mentor.mentorDto.appControlDto
            .automaticChatMessageWhenOffline;
        if (automaticMessageWhenOffline !== '') {
          startChatObj.automaticMessage = automaticMessageWhenOffline;
        } else startChatObj.automaticMessage = automaticMessage;
      }

      this.prevPeersStatus[this.props.mentor.mentorDto.mentorOwnerId] =
        this.context.peersStatus[this.props.mentor.mentorDto.mentorOwnerId];

      this.createNewChatBoxIfRequired(chatRoomDto, startChatObj);
      this.setState({selectedChatRoomDto: chatRoomDto});
    }
  };

  setOfflineClientRoomDto = (
    roomDto,
    messageText,
    isEmailBtnFlow,
    nativeAcceptCallBack,
  ) => {
    if (
      roomDto.ownerObjectType ===
      VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR
    ) {
      const roomExMentorDto =
        expertHomeService.getWidgetDtoExMentorDtoUsingTeamMentorId(
          this.props.expertHomeContext.widgetDtos,
          roomDto.ownerObjectId,
        );
      if (
        !roomExMentorDto.extendedMentorDto.mentorDto.publicEmail &&
        !roomDto.isActive
      ) {
        if (VIDABOO_CONSTANTS.NATIVE_APP) {
          this.context.setNotificationPopUpData({
            notificationTxt: this.context.isAccountManager
              ? 'Update your public email before sending the email'
              : 'Please ask your website administrator to update public email of this widget',
            acceptBtnTxt: 'Update',
            acceptBtnFunc: () => {
              this.callSendMessageFunc(messageText);
              this.resetEmailForm();
              if (nativeAcceptCallBack) nativeAcceptCallBack();
              this.context.closeNotificationPopUp();
            },
            closeBtnTxt: 'Close',
            closeBtnFunc: () => {
              this.context.closeNotificationPopUp();
              this.callSendMessageFunc(messageText);
              this.resetEmailForm();
            },
          });
          this.context.setShowNotificationPopUp(true);
        } else {
          this.context.setNotificationPopUpData({
            notificationTxt: this.context.isAccountManager
              ? 'Update your public email before sending the email'
              : 'Please ask your website administrator to update public email of this widget',
            acceptBtnTxt: this.context.isAccountManager ? 'Update' : null,
            acceptBtnFunc: () => {
              this.callSendMessageFunc(messageText);
              this.resetEmailForm();
              const ROUTES = utilsService.getRoutesEnumByImpersonationMode(
                this.context.isImpersonatedModeActive,
              );
              this.props.history.push(ROUTES.EXPERT_SETTINGS, {
                navUrl:
                  'widgetSetup/setUpInstallation/generalInfo/generalInfoWidgetView',
              });
              this.context.closeNotificationPopUp();
            },
            closeBtnTxt: 'Close',
            closeBtnFunc: () => {
              this.context.closeNotificationPopUp();
              this.callSendMessageFunc(messageText);
              this.resetEmailForm();
            },
          });
          this.context.setShowNotificationPopUp(true);
        }
        return;
      }
    }
    this.setState({offlineClientRoomDto: roomDto}, () => {
      if (
        isEmailBtnFlow ||
        (this.state.offlineClientRoomDto &&
          !this.state.offlineClientRoomDto.isActive) // holds whether the peer is available or not. Coming from Aquarium
      ) {
        //if peerEmail is available
        // if (this.state.offlineClientRoomDto.chatRoomPeerInfoDto.peerEmail) {
        //Check if email have been already sent to user or not
        let _emailReceivedRooms = [...this.state.emailReceivedRooms];
        const _roomDto = this.state.emailReceivedRooms.find(
          (roomDto) =>
            this.state.offlineClientRoomDto.roomId === roomDto.roomId,
        );
        if (_roomDto) {
          if (!isEmailBtnFlow) {
            this.callSendMessageFunc(messageText);
            this.resetEmailForm();
            return;
          }
        } else {
          _emailReceivedRooms.push({roomId: roomDto.roomId});
        }
        let offlineClientEmails = null,
          areAllClientEmailsValid = true;
        if (this.state.offlineClientRoomDto.chatRoomPeerInfoDto.peerEmail) {
          offlineClientEmails = [
            {
              email:
                this.state.offlineClientRoomDto.chatRoomPeerInfoDto.peerEmail,
              isValid: true,
            },
          ];
          areAllClientEmailsValid = true;
        } else {
          areAllClientEmailsValid = false;
        }
        this.setState({
          sendEmailToOfflineClient: true,
          isEmailBtnFlow,
          offlineClientEmailContent: messageText,
          offlineClientEmails,
          areAllClientEmailsValid,
          emailReceivedRooms: _emailReceivedRooms,
          offlineClientRoomDtoMentorId: roomDto.ownerObjectId,
        });
        // } else {
        //if peerEmail is not available, show popup message only once
        // this.callSendMessageFunc(messageText);
        // const _roomDto = this.state.notificationPopupRecievedRooms.find(
        //   (roomDto) =>
        //     this.state.offlineClientRoomDto.roomId === roomDto.roomId,
        // );
        // if (_roomDto) {
        //   return;
        // }
        // let _notificationPopupRecievedRooms = [
        //   ...this.state.notificationPopupRecievedRooms,
        // ];
        // _notificationPopupRecievedRooms.push({roomId: roomDto.roomId});
        // this.setState({
        //   notificationPopupRecievedRooms: _notificationPopupRecievedRooms,
        //   showNotificationPopup: true,
        //   notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.LIGHT,
        //   notificationText:
        //     'Your message will be seen by this customers only if they return to your website.',
        //   closeBtnTxt: 'OK',
        //   closeBtnFunc: this.handleNotificationCloseBtn,
        // });
        // }
      } else {
        this.callSendMessageFunc(messageText);
        this.resetEmailForm();
      }
    });
  };

  handleEmailFormContent = (event) => {
    this.setState({offlineClientEmailContent: event.target.value});
  };

  handleEmailFormSubject = (id, value) => {
    this.setState({offlineClientEmailSubject: value});
  };

  handleOfflineClientEmails = (
    offlineClientEmails,
    areAllClientEmailsValid,
  ) => {
    this.setState({offlineClientEmails, areAllClientEmailsValid});
  };
  handleEmailFormSubmit = async () => {
    const customerEmails = Object.values(this.state.offlineClientEmails).map(
      (emailObj) => emailObj.email,
    );

    const messageToMentor = {
      subject: this.state.offlineClientEmailSubject,
      content: this.state.offlineClientEmailContent,
      // recipientEmail: email, //todo : not used. should we send?
    };
    this.setState({showEmailSpinner: true});
    for (const customerEmail of customerEmails) {
      try {
        const requestObj = {
          customerEmail: customerEmail,
          subject: this.state.offlineClientEmailSubject,
          content: this.state.offlineClientEmailContent,
          mentorId: this.state.offlineClientRoomDtoMentorId,
        };
        const response =
          await NotifyCustomerService.sendMessageByEmail(requestObj);
        if (!response.success) {
          throw response;
        }
      } catch (error) {
        this.setState({
          showEmailSpinner: false,
          showNotificationPopup: true,
          notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
          notificationText: 'Unable to send email at this time.',
          closeBtnTxt: 'OK',
          closeBtnFunc: this.handleNotificationCloseBtn,
        });
        this.resetEmailForm();
        return;
      }
    }
    this.callSendMessageFunc(
      'Outbound Email',
      VIDABOO_CONSTANTS.CHAT_SUBTYPES.OB_EMAIL,
      JSON.stringify(messageToMentor),
    );
    this.setState({
      showEmailSpinner: false,
      showNotificationPopup: true,
      notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.LIGHT,
      notificationText: 'Your message has been sent to your customer by email.',
      closeBtnTxt: 'OK',
      closeBtnFunc: this.handleNotificationCloseBtn,
    });
    this.resetEmailForm();
  };
  resetEmailForm = (isCancelBtnClicked) => {
    if (
      this.state.offlineClientRoomDto &&
      isCancelBtnClicked &&
      !this.state.isEmailBtnFlow
    ) {
      if (this.state.offlineClientEmailContent?.length > 0)
        this.callSendMessageFunc(this.state.offlineClientEmailContent);
      const _roomDto = this.state.emailReceivedRooms.find(
        (roomDto) => this.state.offlineClientRoomDto.roomId === roomDto.roomId,
      );
      if (_roomDto) {
        let _emailReceivedRooms = this.state.emailReceivedRooms.filter(
          (roomDto) => roomDto.roomId !== _roomDto.roomId,
        );
        this.setState({emailReceivedRooms: _emailReceivedRooms});
      }
    }
    this.setState({
      showEmailSpinner: false,
      sendEmailToOfflineClient: false,
      isEmailBtnFlow: false,
      offlineClientEmails: null,
      areAllClientEmailsValid: true,
      offlineClientEmailSubject: 'You asked a question. Response here',
      offlineClientEmailContent: null,
      offlineClientRoomDto: null,
      offlineClientRoomDtoMentorId: null,
    });
  };

  handleNotificationCloseBtn = () => {
    this.setState({
      showNotificationPopup: false,
      notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.DARK,
      notificationText: '',
      acceptBtnTxt: '',
      acceptBtnFunc: null,
      closeBtnTxt: '',
      closeBtnFunc: null,
    });
  };
  updateReadMessagesByMessageTag = (roomId, newReadMessagesByMessageTag) => {
    const chatBox = this.state.chatBoxes[roomId];
    chatBox.readMessagesByMessageTag = newReadMessagesByMessageTag;
    const chatBoxes = {...this.state.chatBoxes[roomId]};
    chatBoxes[roomId] = chatBox;
    this.setState({chatBoxes});
  };
  updateChatMessages = (roomId, chatMessages) => {
    const chatBox = this.state.chatBoxes[roomId];
    chatBox.chatMessages = chatMessages;
    const chatBoxes = {...this.state.chatBoxes[roomId]};
    chatBoxes[roomId] = chatBox;
    this.setState({chatBoxes});
  };

  render() {
    // console.debug(
    //   'selectedWidgetAppType = ',
    //   this.props.selectedWidgetAppType,
    //   ' shouldCollectUserInfo: ',
    //   this.state.shouldCollectUserInfo,
    //   ' showChatContainer: ',
    //   this.state.showChatContainer,
    // );
    // console.debug(
    //   'Render? ',
    //   ((this.props.selectedWidgetAppType !==
    //     VIDABOO_CONSTANTS.WIDGET_APP_TYPES.NONE &&
    //     this.props.selectedWidgetAppType !==
    //       VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT) ||
    //     !this.state.shouldCollectUserInfo) &&
    //     (this.props.selectedWidgetAppType || this.props.isMentor) &&
    //     this.state.showChatContainer,
    // );
    return (
      <React.Fragment>
        {VIDABOO_CONSTANTS.NATIVE_APP ? (
          <>
            <ChatContainerRender
              state={this.state}
              props={this.props}
              params={this.props.params}
              refToChatBoxFnc={(ref) => {
                this.refToChatBox = ref;
              }}
              updateReadMessagesByMessageTag={
                this.updateReadMessagesByMessageTag
              }
              updateChatMessages={this.updateChatMessages}
              openCloseSendFileComponent={this.openCloseSendFileComponent}
              handleFileDrop={this.handleFileDrop}
              onFileDrag={this.onFileDrag}
              setOfflineClientRoomDto={this.setOfflineClientRoomDto}
              handleTransitionChatRoomOwnership={
                this.handleTransitionChatRoomOwnership
              }
              handleTaskOwnerLockChange={this.handleTaskOwnerLockChange}
            />
          </>
        ) : (
          <>
            {this.props.isPersonalPage && this.props.ppChatTitleComp}
            {/* MAGIC. DON'T TOUCH UNLESS YOU FULLY UNDERSTAND  https://consolto.atlassian.net/browse/CFW-1019 */}
            <div
              className={
                this.props.selectedWidgetAppType !==
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.NONE &&
                (this.props.selectedWidgetAppType || this.props.isMentor) &&
                (this.state.showChatContainer ||
                  this.props.isPersonalPage ||
                  utilsService.getIsClient())
                  ? this.props.isPersonalPage
                    ? 'et-personal-page-right-content-wrap et-pp-chat-container-wrap'
                    : 'et-chat-container-shown'
                  : 'et-chat-container-hidden'
              }>
              {utilsService.getIsClient() && !this.state.showChatContainer ? (
                <ShimmerWithEmptyImageComponent
                  shimmerComponentType={
                    VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES
                      .CLIENT_CHAT_CONTAINER
                  }
                />
              ) : (
                <ChatContainerRender
                  state={this.state}
                  props={this.props}
                  params={this.props.params}
                  refToChatBoxFnc={(ref) => {
                    this.refToChatBox = ref;
                  }}
                  updateReadMessagesByMessageTag={
                    this.updateReadMessagesByMessageTag
                  }
                  updateChatRoomLastMessage={
                    this.props.updateChatRoomLastMessage
                  }
                  updateChatRoomReadersReadMessagesMap={
                    this.props.updateChatRoomReadersReadMessagesMap
                  }
                  updateChatMessages={this.updateChatMessages}
                  openCloseSendFileComponent={this.openCloseSendFileComponent}
                  handleFileDrop={this.handleFileDrop}
                  onFileDrag={this.onFileDrag}
                  setOfflineClientRoomDto={this.setOfflineClientRoomDto}
                  handleTransitionChatRoomOwnership={
                    this.handleTransitionChatRoomOwnership
                  }
                  handleTaskOwnerLockChange={this.handleTaskOwnerLockChange}
                  showLeadCollector={
                    !this.props.isMentor && this.state.shouldCollectUserInfo
                  }
                  callSendMessageFunc={this.callSendMessageFunc}
                  callbackSuccessInfoSend={() =>
                    this.setState({
                      shouldCollectUserInfo: false,
                    })
                  }
                />
              )}
            </div>
          </>
        )}
        {/* {!this.props.isMentor && this.state.shouldCollectUserInfo && (
          <LeadCollectorComponent
            isDemo={this.props.isDemo}
            isPersonalPage={this.props.isPersonalPage}
            callSendMessageFunc={this.callSendMessageFunc}
            mentor={this.props.mentor}
            selectedWidgetAppType={VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT}
            callbackSuccessInfoSend={() => {
              this.setState({shouldCollectUserInfo: false});
            }}
          />
        )} */}
        {this.state.sendEmailToOfflineClient && (
          <SendMailComponent
            areAllClientEmailsValid={this.state.areAllClientEmailsValid}
            isEmailBtnFlow={this.state.isEmailBtnFlow}
            showEmailSpinner={this.state.showEmailSpinner}
            offlineClientEmails={this.state.offlineClientEmails}
            emailSubject={this.state.offlineClientEmailSubject}
            messageToSend={this.state.offlineClientEmailContent}
            handleSubjectChange={this.handleEmailFormSubject}
            handleContentChange={this.handleEmailFormContent}
            handleOfflineClientEmails={this.handleOfflineClientEmails}
            handleSubmit={this.handleEmailFormSubmit}
            handleCancel={this.resetEmailForm}
          />
        )}
        {this.state.showNotificationPopup && (
          <NotificationComponent
            notificationType={this.state.notificationType}
            notificationTxt={this.state.notificationText}
            acceptBtnFunc={this.state.acceptBtnFunc}
            acceptBtnTxt={this.state.acceptBtnTxt}
            closeBtnTxt={this.state.closeBtnTxt}
            closeBtnFunc={this.state.closeBtnFunc}
          />
        )}
      </React.Fragment>
    );
  }
}

ChatContainer.contextType = AppContext;
const ChatContainerComponent = withExpertHomeContext(
  withWidgetContext(
    VIDABOO_CONSTANTS.NATIVE_APP ? ChatContainer : withRouter(ChatContainer),
  ),
);
export default ChatContainerComponent;
